import {action, observable} from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import {DomainStore} from 'shared/store';
import {t} from 'shared/core';
import {successAlert} from 'shared/tools';
import {PayrollUpdate} from 'stores/payroll';

class PayrollUpdatesListState {
  store = new DomainStore();
  interactiveAgent;
  
  @observable payrollUpdates = [];
  @observable isLoading = false;

  setInteractiveAgent(agent) {
    this.interactiveAgent = agent;
  }

  @action async updatePayrollUpdateStatus(payrollUpdate) {
    const newStatus = payrollUpdate.status === 'submitted' ? 'completed' : 'submitted';

    const payrollUpdateCopy = new PayrollUpdate(payrollUpdate);
    payrollUpdateCopy.merge({status: newStatus});

    const {model} = await this.store.patch(payrollUpdateCopy);

    if (model) {
      payrollUpdate.update(model);
      this.interactiveAgent.refresh();
      successAlert(t('payroll_updates.alerts.Updated payroll update'));
    }
  }

  payrollUpdatesGroupedByDate(payrollUpdates) {
    const groupedUpdates = _.groupBy(
      payrollUpdates, payrollUpdate => moment(payrollUpdate.createdAt).format('YYYYMMDD')
    );

    const groups = _.map(groupedUpdates,
      items => ({
        date: items[0].createdAt,
        items
      })
    );

    return _.orderBy(groups, 'date', 'desc');
  }
}

export default PayrollUpdatesListState;
